import PlayerCard from "../../Components/PlayersCard/playerCard"
function Team() {
    return (
        <>
            <main>
                <PlayerCard />
            </main>
        </>
    )
}

export default Team